export const mockVariant = {
  id: "17-41245466-G-A",
  rsid: "rs80357914",
  chromosome: "17",
  position: 41245466,
  ref: "G",
  alt: "A",
  gene: "BRCA1",
  transcript: "ENST00000357654.9",
  consequence: "frameshift_variant",
  hgvsc: "NM_007294.4:c.5266dupC",
  hgvsp: "p.Gln1756ProfsTer25",
  exon: "20/23",

  scores: {
    phactboost: { score: 0.923, label: "Pathogenic" },
    alphamissense: { score: 0.87, label: "Likely Pathogenic" },
    gpnMsa: { score: 0.91, label: "Pathogenic" },
    spliceAI: { ds_ag: 0.02, ds_al: 0.01, ds_dg: 0.05, ds_dl: 0.03, max: 0.05, label: "Low" },
    dbscSNV_ada: { score: 0.78, label: "Moderate" },
    dbscSNV_rf: { score: 0.81, label: "Likely Pathogenic" },
    revel: { score: 0.89, label: "Pathogenic" },
  },

  gnomad: {
    version: "v4.0",
    global_af: 0.0000283,
    global_ac: 7,
    global_an: 247298,
    homozygotes: 0,
    populations: [
      { name: "African/African American", code: "afr", af: 0.0000118, ac: 2, an: 169492 },
      { name: "Admixed American", code: "amr", af: 0.0000432, ac: 3, an: 69404 },
      { name: "Ashkenazi Jewish", code: "asj", af: 0.000891, ac: 1, an: 11224 },
      { name: "East Asian", code: "eas", af: 0.0, ac: 0, an: 17596 },
      { name: "Finnish", code: "fin", af: 0.0000231, ac: 1, an: 43268 },
      { name: "Non-Finnish European", code: "nfe", af: 0.0000412, ac: 0, an: 113558 },
      { name: "South Asian", code: "sas", af: 0.0000076, ac: 0, an: 131388 },
      { name: "Other", code: "oth", af: 0.0000189, ac: 0, an: 26548 },
    ],
  },

  clinvar: {
    id: "VCV000037596",
    variation_id: "37596",
    significance: "Pathogenic",
    review_status: "reviewed by expert panel",
    review_stars: 4,
    conditions: [
      { name: "Hereditary breast and ovarian cancer syndrome", medgen: "C0677776" },
      { name: "Breast-ovarian cancer, familial, susceptibility to, 1", medgen: "C2676676" },
    ],
    submissions: 47,
    last_evaluated: "2024-01-15",
    allele_id: 52425,
  },

  acmg: {
    classification: "Pathogenic",
    score: 10,
    criteria: [
      {
        code: "PVS1",
        description: "Null variant (frameshift) in a gene where LOF is known disease mechanism",
        strength: "Very Strong",
        met: true,
      },
      {
        code: "PS3",
        description: "Well-established functional studies show damaging effect",
        strength: "Strong",
        met: true,
      },
      {
        code: "PM2",
        description: "Absent from controls in gnomAD (AF < 0.0001)",
        strength: "Moderate",
        met: true,
      },
      {
        code: "PP5",
        description: "Reputable source recently reports variant as pathogenic",
        strength: "Supporting",
        met: true,
      },
    ],
    explanation:
      "This frameshift variant in BRCA1 creates a premature stop codon at position 1756, leading to a truncated protein that lacks key functional domains including the BRCT domain required for DNA damage response. Loss of function is a well-established mechanism for BRCA1-associated cancers. The variant is absent from gnomAD controls and has been classified as Pathogenic by the ENIGMA expert panel.",
  },

  gene_info: {
    symbol: "BRCA1",
    full_name: "BRCA1 DNA Repair Associated",
    omim: "113705",
    omim_phenotype: "Breast-ovarian cancer, familial, susceptibility to, 1 (MIM#604370)",
    orphanet: "ORPHA145",
    orphanet_disease: "Hereditary breast and ovarian cancer syndrome",
    clingen_gene_id: "HGNC:1100",
    inheritance: ["AD"],
    gnomad_pLI: 0.9992,
    gnomad_loeuf: 0.12,
    gnomad_z_missense: 3.09,
    haploinsufficiency: { score: 3, label: "Sufficient evidence for HI", color: "red" },
    triplosensitivity: { score: 1, label: "Little evidence for TS", color: "gray" },
    function:
      "Tumor suppressor involved in DNA damage repair via homologous recombination. Interacts with RAD51 and forms BRCA1-BARD1 E3 ubiquitin ligase complex. Essential for maintaining genomic stability and cell cycle checkpoint control. BRCA1 protein contains RING, BRCT, and coiled-coil domains, each critical for distinct protein-protein interactions and enzymatic activities.",
    expression: ["breast", "ovary", "testis", "thymus"],
  },

  publications: [
    {
      pmid: "38765432",
      title: "BRCA1 c.5266dupC pathogenicity confirmed in multi-center cohort study",
      journal: "Nature Genetics",
      year: 2024,
      authors: "Chen L, et al.",
      doi: "10.1038/s41588-024-01234-5",
    },
    {
      pmid: "36812901",
      title: "Functional impact of frameshift variants in BRCA1 BRCT domain",
      journal: "American Journal of Human Genetics",
      year: 2023,
      authors: "Rodriguez M, et al.",
      doi: "10.1016/j.ajhg.2023.01.018",
    },
    {
      pmid: "35234189",
      title: "Population-based screening identifies recurrent BRCA1 variants in diverse cohorts",
      journal: "JAMA Oncology",
      year: 2022,
      authors: "Smith K, et al.",
      doi: "10.1001/jamaoncol.2022.0123",
    },
    {
      pmid: "34019207",
      title: "ENIGMA BRCA1/2 variant classification guidelines update 2021",
      journal: "Human Mutation",
      year: 2021,
      authors: "Parsons MT, et al.",
      doi: "10.1002/humu.24216",
    },
    {
      pmid: "32398448",
      title: "Clinical significance of BRCA1 truncating variants in cancer prevention",
      journal: "Cancer Research",
      year: 2020,
      authors: "Johnson A, et al.",
      doi: "10.1158/0008-5472.CAN-19-3847",
    },
  ],

  mgs: {
    score: 0.947,
    classification: "High Risk",
    percentile: 97.4,
    components: {
      functional_impact: 0.95,
      population_rarity: 0.88,
      conservation: 0.92,
      clinical_evidence: 0.99,
    },
  },

  nearby_variants: [
    { pos: 41245200, id: "rs1799950", consequence: "missense", af: 0.001, pathogenicity: 0.4 },
    { pos: 41245350, id: "rs80357540", consequence: "synonymous", af: 0.0002, pathogenicity: 0.1 },
    { pos: 41245700, id: "rs80357713", consequence: "splice_region", af: 0.00001, pathogenicity: 0.75 },
    { pos: 41246100, id: "rs1800709", consequence: "missense", af: 0.005, pathogenicity: 0.55 },
    { pos: 41244800, id: "rs799917", consequence: "synonymous", af: 0.48, pathogenicity: 0.05 },
  ],

  exons: [
    { number: 17, start: 41243452, end: 41246877 },
    { number: 18, start: 41247862, end: 41247939 },
    { number: 19, start: 41249261, end: 41249306 },
    { number: 20, start: 41251791, end: 41251897 },
    { number: 21, start: 41256139, end: 41256278 },
    { number: 22, start: 41258473, end: 41258550 },
    { number: 23, start: 41267743, end: 41267853 },
  ],

  phenomeAI: {
    status: "idle",
    diseases: [
      { name: "Hereditary Breast and Ovarian Cancer", probability: 0.94, hpo: "HP:0003002" },
      { name: "Li-Fraumeni Syndrome", probability: 0.12, hpo: "HP:0000805" },
      { name: "Fanconi Anemia", probability: 0.08, hpo: "HP:0001877" },
    ],
    phenotypes: [
      { name: "Breast carcinoma", probability: 0.96, hpo: "HP:0003002" },
      { name: "Ovarian neoplasm", probability: 0.81, hpo: "HP:0100615" },
      { name: "Increased risk for breast cancer", probability: 0.97, hpo: "HP:0003002" },
    ],
  },
};

export const searchHistory = ["1-12345-A-T", "rs334", "BRCA2", "17-41245466-G-A"];
